<template>
  <div class="container">
    <div class="kalkulacija-container">
      <div class="left">
        <div class="image">
          <img v-if="get_class === 'a'" src="../../assets/images/desktop/emoticon_sjajno.svg" alt="" />
          <img v-else-if="get_class === 'b'" src="../../assets/images/desktop/emoticon_warning.svg" alt="" />
          <img v-else src="../../assets/images/desktop/emoticon_danger.svg" alt="" />
        </div>
        <div :class="{ title: true, green: get_class === 'a', yellow: get_class === 'b', red: get_class === 'c' }">
          {{ main_data["calc_title_" + get_class].title }}
        </div>
        <div :class="{ subtitle: true, green: get_class === 'a', yellow: get_class === 'b', red: get_class === 'c' }">
          {{ main_data["calc_subtitle_" + get_class].title }}
        </div>
        <div class="description">{{ main_data["calc_description_" + get_class].title }}</div>
      </div>
      <div class="right">
        <div class="top">
          <div class="title">
            {{ uppercase(main_data.calc_year.title) }}
          </div>
          <template v-for="(row_type, index) in main_data.calc_order.value.split(';')">
            <div v-if="row_type === 'E'" :class="['row', index === 0 ? 'first' : '']" :key="row_type">
              <div class="row-left">
                <img :src="getCurrencyIconUrl()" alt="" />
              </div>
              <div class="row-right euro">{{ app_math.numberWithCommas(get_final_calculation.existing.cena) }}</div>
            </div>
            <div v-if="row_type === 'C'" :class="['row', index === 0 ? 'first' : '']" :key="row_type">
              <div class="row-left">
                <img src="../../assets/images/desktop/co2_ikonica.svg" alt="" />
              </div>
              <div class="row-right co2">{{ app_math.numberWithCommas(get_final_calculation.existing.co2) }}</div>
            </div>
            <div v-if="row_type === 'H'" :class="['row', index === 0 ? 'first' : '']" :key="row_type">
              <div class="row-left">
                <img src="../../assets/images/desktop/grejanje_ikonica.svg" alt="" />
              </div>
              <div class="row-right energy">
                {{
                  app_math.numberWithCommas(
                    settings.show_potrebno
                      ? get_final_calculation.existing.final
                      : get_final_calculation.existing.final_grejanje
                  )
                }}
              </div>
            </div>
          </template>

          <!-- <div class="spacer"></div>
          <div class="en-class">
            <div class="en-class-left">{{ main_data.calc_class.title }}</div>
            <div class="en-class-right" :style="{ color: get_energy_color }">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 213.473 95.238">
                <path
                  id="XMLID_14_"
                  fill="currentColor"
                  d="M-237.2 341.238H-421V246h183.8l29.673 47.619z"
                  transform="translate(421 -246)"
                />
              </svg>

              <img
                :src="
                  require('../../assets/images/energija/' + get_final_calculation.existing.energetski_razred + '.svg')
                "
                alt=""
              />
            </div>
          </div> -->
        </div>
        <div class="bottom" @click="$emit('confirm-step', 6)">
          {{ main_data.calc_confirm.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  .kalkulacija-container {
    width: 96rem;
    height: 71rem;
    display: flex;
    justify-content: space-between;
    text-align: center;
    color: $text-white;
    align-items: center;

    .left {
      width: 39rem;
      display: flex;
      flex-direction: column;
      align-items: center;

      .image {
        margin-top: 1rem;
        margin-bottom: 1rem;
        width: 26rem;
        height: 26rem;

        img {
          width: 100%;
          max-width: 100%;
        }
      }

      .title {
        font-family: F-Dem;
        font-size: 6.5rem;
        line-height: 0.89;
        margin-top: 0.5rem;

        &.green {
          color: $desktop_green;
        }

        &.red {
          color: $calc_back;
        }

        &.yellow {
          color: $calc_warning;
        }
      }

      .subtitle {
        font-size: 3.4rem;
        line-height: 1.24;
        margin-top: 1.5rem;

        &.green {
          color: $desktop_green;
        }

        &.red {
          color: $calc_back;
        }

        &.yellow {
          color: $calc_warning;
        }
      }

      .description {
        margin-top: 4rem;
        font-size: 2.2rem;
        line-height: 1.18;
        margin-bottom: 3rem;
      }
    }

    .right {
      width: 51rem;
      display: flex;
      flex-direction: column;

      .top {
        background-color: $main_header_middle;
        border-radius: 5.3rem;
        padding: 3.5rem 4.6rem 3.5rem 3.5rem;
        margin-bottom: 3.5rem;

        .title {
          font-family: F-Dem;
          font-size: 2.2rem;
          line-height: 0.8;
          color: $main_header_light;
          padding-bottom: 2rem;
          border-bottom: 1px solid $main_header_light;
        }

        .row {
          margin: 0 1.2rem 2rem 1.2rem;
          display: flex;
          height: 9.5rem;

          &.first {
            margin-top: 2.1rem;
            height: 17.5rem;

            .row-left {
              height: 9.5rem;
              align-self: center;
            }
          }

          .row-left {
            flex-grow: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 15rem;

            img {
              height: 80%;
              max-height: 80%;
              width: auto;
            }
          }

          .row-right {
            width: 23rem;
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: F-Dem;
            font-size: 3.6rem;
            line-height: 0.5;

            &.euro {
              background-image: linear-gradient(to top, #24c46c, #2e7285);
            }

            &.co2 {
              background-image: linear-gradient(to top, #919191, #2e7285);
            }

            &.energy {
              background-image: linear-gradient(to top, #f05a28, #2e7285);
            }
          }
        }

        .spacer {
          border-top: 1px solid $main_header_light;
          height: 2.5rem;
        }

        .en-class {
          margin: 0 4.5rem 0 1.6rem;
          display: flex;
          height: 9.5rem;

          .en-class-left {
            display: flex;
            align-items: center;
            font-size: 2.4rem;
            line-height: 1.17;
            flex-grow: 1;
            text-align: left;
          }

          .en-class-right {
            width: 22rem;
            position: relative;

            svg {
              max-height: 100%;
              height: 100%;
            }

            img {
              position: absolute;
              height: 6.5rem;
              max-height: 6.5rem;
              left: 2rem;
              top: 1.5rem;
              width: auto;
              z-index: 1;
            }
          }
        }
      }

      .bottom {
        height: 8.8rem;
        background-color: $calc_button;
        border-radius: 4.4rem;
        font-size: 2.9rem;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
    }
  }
}
</style>

<script>
import mixin from "../../lib/mixins.js";
import app_math from "../../lib/math.js";
import settings from "../../Settings";

export default {
  mixins: [mixin],
  props: ["main_data", "get_final_calculation"],
  data: function () {
    return {
      app_math,
      settings: settings,
    };
  },
  computed: {
    get_energy_color: function () {
      if (this.get_final_calculation.existing.energetski_razred === "G") return "#d2171e";
      if (this.get_final_calculation.existing.energetski_razred === "F") return "#ff400e";
      if (this.get_final_calculation.existing.energetski_razred === "E") return "#fe7309";
      if (this.get_final_calculation.existing.energetski_razred === "D") return "#f9a51a";
      if (this.get_final_calculation.existing.energetski_razred === "C") return "#f9ea1a";
      if (this.get_final_calculation.existing.energetski_razred === "B") return "#a9d82a";
      if (this.get_final_calculation.existing.energetski_razred === "A") return "#2db46a";
      return "#179249";
    },
    get_class: function () {
      if (
        this.get_final_calculation.existing.energetski_razred === "A+" ||
        this.get_final_calculation.existing.energetski_razred === "A" ||
        this.get_final_calculation.existing.energetski_razred === "B" ||
        this.get_final_calculation.existing.energetski_razred === "C"
      )
        return "a";
      if (this.get_final_calculation.existing.energetski_razred === "D") return "b";
      return "c";
    },
  },
  methods: {
    getCurrencyIconUrl: function () {
      const icon_name = this.main_data.currency_icon.value;
      return require("../../assets/images/currency/" + icon_name + ".svg");
    },
  },
};
</script>
